import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FocusOnInitDirective, FocusOnViewEnterDirective } from './focus-on-init.directive';

@NgModule({
  declarations: [
    FocusOnInitDirective,
    FocusOnViewEnterDirective,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    FocusOnInitDirective,
    FocusOnViewEnterDirective,
  ],
})
export class FocusOnInitDirectiveModule { }
